define('root/tasks/Podio.Transport.Tasks',['require','jquery','lib/Podio.Transport','lib/Podio.Routes'],function(require) {

  var $ = require('jquery');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  function deleteTask(task_id, callback) {
    var url = routes.json_task_path(task_id);
    transport.deleteJSON(url, {}, callback);
  }

  function completeTask(task_id, callback) {
    var url = routes.complete_json_task_path(task_id);
    transport.postJSON(url, {}, callback);
  }

  function uncompleteTask(task_id, callback) {
    var url = routes.uncomplete_json_task_path(task_id);
    transport.postJSON(url, {}, callback);
  }

  function getTask(task_id, callback) {
    var url = routes.json_task_path(task_id);
    transport.getJSON(url, {}, callback);
  }

  function getTasks(offset, taskGroup, taskFilter, spaceName, taskGrouping, externalId, callback) {
    var url;
    if (spaceName) {
      url = routes.spaces_tasks_with_current_space_path();
    } else {
      url = routes.json_task_index_path();
    }

    transport.getJSON(url, {'requestData': {'offset': offset, 'task_group': taskGroup, 'show': taskFilter, 'group_by': taskGrouping, 'external_id': externalId || undefined }}, callback);
  }

  function getSidebarTasks(spaceName, ref_type, ref_id, callback) {
    var url;
    if (spaceName) {
      url = routes.space_task_sidebar_with_current_space_path(ref_type, ref_id);
    } else {
      url = routes.sidebar_json_task_index_path(ref_type, ref_id);
    }
    transport.getJSON(url, {}, callback);
  }

  function updateTaskField(task_id, field, dataValues, isSingleView, callback) {
    var url = routes.json_task_path(task_id);

    var defaultRequestData = {
      'field': field,
      'is_single_view': isSingleView
    };

    var requestData = $.extend({}, defaultRequestData, dataValues);

    return transport.putJSON(url, {'requestData': requestData }, callback);
  }

  function rankTask(taskID, prevTaskID, nextTaskID, callback) {
    var url = routes.rank_json_task_path(taskID);
    transport.postJSON(url, {'requestData': {'prev_task_id': prevTaskID, 'next_task_id': nextTaskID}}, callback);
  }

  function attachFileToTask(taskId, fileId, callback) {
    var url = routes.attach_file_json_task_path(taskId);
    transport.postJSON(url, {'requestData': {'file_id': fileId}}, callback);
  }

  function createTaskLabel(requestData, callback) {
    var url = routes.task_labels_path();
    transport.postJSON(url, {'requestData': requestData}, callback);
  }

  function deleteTaskLabel(labelId, callback) {
    var url = routes.task_label_path(labelId);
    transport.deleteJSON(url, {}, callback);
  }

  function updateTaskLabel(labelId, text, color, callback) {
    var url = routes.task_label_path(labelId);
    transport.putJSON(url, {'requestData': {'task_label[text]': text, 'task_label[color]': color}}, callback);
  }

  function getTaskLabels(callback) {
    var url = routes.task_labels_path();
    transport.getJSON(url, {}, callback);
  }


  function updateTaskReference(taskId, ref_type, ref_id, callback) {
    var url = routes.update_reference_json_task_path(taskId);
    transport.putJSON(url, {'requestData': {'ref_type': ref_type, 'ref_id': ref_id}}, callback);
  }

  return {
    deleteTask: deleteTask,
    completeTask: completeTask,
    uncompleteTask: uncompleteTask,
    rankTask: rankTask,
    updateTaskField: updateTaskField,
    updateTaskReference : updateTaskReference,
    getTask: getTask,
    getTasks: getTasks,
    attachFileToTask: attachFileToTask,
    createTaskLabel : createTaskLabel,
    deleteTaskLabel : deleteTaskLabel,
    updateTaskLabel : updateTaskLabel,
    getTaskLabels : getTaskLabels,
    getSidebarTasks : getSidebarTasks
  };

});


